export enum RequestOrderTabEnum {
  InfoTab = 0,
  ServiceableTab = 1,
  UnServiceableTab = 2,
  AlternatePnTab = 3,
  ServiceableReDeliveryTab = 4,
  ShipmentArrivalTab = 5,
  RequestSpt = 6,
}
